export const processEmails = (uploadedEmails: string[], fileName?: string) => {
  const domainMap: Record<string, string[]> = {};
  const generalEmails: string[] = [];
  const MIN_EMAILS_PER_DOMAIN = 20;

  uploadedEmails.forEach((email) => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) return;

    const domain = trimmedEmail.split("@")[1];

    if (!domainMap[domain]) {
      domainMap[domain] = [];
    }
    domainMap[domain].push(trimmedEmail);
  });

  const emailsToHash = Object.entries(domainMap).reduce<{ domain: string; emails: string[] }[]>(
    (acc, [domain, emails]) => {
      if (emails.length < MIN_EMAILS_PER_DOMAIN) {
        generalEmails.push(...emails);
      } else {
        acc.push({ domain, emails });
      }
      return acc;
    },
    [],
  );

  if (generalEmails.length > 0) {
    emailsToHash.push({ domain: "general", emails: generalEmails });
  }

  return {
    emailsToHash,
    fromFile: fileName || null,
  };
};
